import classNames from "classnames";

type LoadingIconProps = {
  className?: string;
  size?: number;
  loading?: boolean;
  showBackground?: boolean;
};

export const LoadingIcon = ({
  className,
  size = 20,
  loading = true,
  showBackground = true,
}: LoadingIconProps) => {
  return (
    <div className={classNames(className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 17"
        fill="none"
        className="animate-spin"
      >
        {/* Background circle */}
        <circle
          cx="8"
          cy="8.5"
          r="6.5"
          stroke={showBackground ? "var(--cdl-bg-subtle)" : "transparent"}
          strokeWidth="2.5"
          fill="none"
        />
        {/* Foreground spinning arc */}
        {loading && (
          <circle
            cx="8"
            cy="8.5"
            r="6.5"
            stroke="currentColor"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="square"
            strokeDasharray="20 20"
            transform="rotate(-90 8 8.5)"
          />
        )}
      </svg>
    </div>
  );
};
